/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Filter_ShowInputs */

const en_filter_show = /** @type {(inputs: Filter_ShowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show ${i?.count} recipes`)
};

const de_filter_show = /** @type {(inputs: Filter_ShowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Rezepte anzeigen`)
};

/**
* | output |
* | --- |
* | "Show {count} recipes" |
*
* @param {Filter_ShowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_show = /** @type {((inputs: Filter_ShowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_ShowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_show(inputs)
	return en_filter_show(inputs)
});